<iris-card [elevation]="1">
  <div class="card-contents">
    <h2>Book a session with Dominique</h2>

    <div class="soonest-available">
      <span>Soonest available: Monday June 10</span>
    </div>

    <div class="timezone">
      <p>{{ providerTimeZone | providerTimeZoneString }} timezone displayed</p>
    </div>

    <appointment-carousel></appointment-carousel>

    <iris-card class="session-type" *ngIf="showSessionType">
      <form [formGroup]="providerCalendarFormGroup">
        <iris-radio-group
          [options]="sessionTypeOptions"
          formControlName="sessionTypePreference"
        />
      </form>
    </iris-card>

    <iris-card-footer>  
      <div class="button-container">
        <iris-button
          [buttonType]="irisButtonTypes.PRIMARY"
        >
          Connect without selecting a time
        </iris-button>
      </div>
     </iris-card-footer>
  </div>
</iris-card>
